module.exports = __webpack_public_path__ + "img/YMESicon1.04f86bc7.png";